import { Button, Modal } from "antd";
import React, { useState } from "react";
import { TituloModal } from "../../../../components/tituloModal/TituloModal";
import { ContenidoModal } from "./_ContenidoModal";

export const ModalOrdenPago = ({ ordenPagoID, texto }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button type="link" onClick={() => setOpen(true)} style={{ padding: 0 }}>
        {texto}
      </Button>

      <Modal
        width={"80%"}
        footer={[
          <Button key={1} onClick={() => setOpen(false)} size="small" danger>
            Cerrar
          </Button>,
        ]}
        title={<TituloModal texto="Orden de Pago" />}
        open={open}
        onCancel={() => setOpen(false)}
      >
        {open && <ContenidoModal ordenPagoID={ordenPagoID} />}
      </Modal>
    </>
  );
};
